<template>
  <div class="header" :class="{ index: searchActive }">
    <!-- <div class="header__left-group">
      <div class="header__search">
        <div class="header__search-icon" @click="toogleSearcher">
          <i class="icon-search"></i>
        </div>
        <transition name="searcher">
          <div class="header__search-input" v-show="searchActive">
            <i class="icon-left-open" @click="toogleSearcher"></i>
            <input type="text" placeholder="Buscar" />
          </div>
        </transition>
      </div>
    </div> -->

    <div class="header__right-group">
      <!-- <div class="header__notify">
        <div class="header__notify-icon">
          <i class="icon-notify"></i>
        </div>
      </div> -->

      <div class="header__user">
        <div class="header__user-business" v-if="!!$store.state.login.currentUser">
          <md-field>
            <md-select v-model="actualBusiness" name="actualBusiness" id="actualBusiness">
              <md-option
                :value="item.id"
                v-for="(item, $index) of $store.state.login.currentUser.business"
                :key="`use-admin-business-${$index}`"
                >{{ item.name }}</md-option
              >
            </md-select>
          </md-field>
        </div>
        <div class="header__user-name">{{ this.fullName }}</div>
        <div class="header__user-arrow" @click="toogleArrow = !toogleArrow">
          <i class="icon-down-open"></i>
        </div>
        <div class="header__user-icon" @click="toogleArrow = !toogleArrow">
          <img :src="imageProfile || require('@/assets/img/user.svg')" alt="" />
        </div>

        <transition name="fade" mode="out-in">
          <div
            class="header__user-logout"
            v-show="toogleArrow"
            @click.self="toogleArrow = !toogleArrow"
          >
            <ul>
              <li @click="logOut()">Cerrar sesión</li>
              <li>Cambiar foto de perfil</li>
            </ul>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  created() {
    this.searchActive = window.innerWidth < 900 ? false : true;
    this.actualBusiness = window.localStorage.getItem("businessID");
  },
  data: () => ({
    searchActive: null,
    toogleArrow: false,
    actualBusiness: null,
  }),

  computed: {
    ...mapGetters({
      fullName: "fullName",
      imageProfile: "getImageProfile",
    }),
  },

  methods: {
    ...mapActions({
      getDetailBusiness: "getDetailBusiness",
    }),
    toogleSearcher() {
      if (window.innerWidth < 900) this.searchActive = !this.searchActive;
    },
    logOut() {
      this.$router.push({ name: "login" });
      this.$localStorage.set("userID", "");
      this.$localStorage.set("businessID", "");
      window.localStorage.clear();
    },
  },
  watch: {
    actualBusiness(n, o) {
      this.$store.commit("SET_BUSINESSID", n);
      console.log(n);
      this.getDetailBusiness(n).then((r) => {
        console.log(r);
      });
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss">
.md-menu-content.md-select-menu {
    z-index: 999;
    width: 100%;
}
</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-VENDORS
//toogle buscador
.index {
  z-index: 400 !important;
}
.searcher-enter-active {
  animation: searcher-in 0.5s;
}
.searcher-leave-active {
  animation: searcher-in 0.5s reverse;
}

.down-menu-user {
  max-height: 100% !important;
  opacity: 1 !important;
}

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

@mixin icon($color, $fz) {
  background-color: rgba($color, 0.15);
  height: 3rem;
  width: 3rem;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-right: 1rem;
  i {
    color: $color;
    font-size: $fz;
  }
}

//keyframes
@keyframes searcher-in {
  0% {
    left: -100%;
    opacity: 0;
    z-index: 100;
  }
  50% {
    left: -50%;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}

//7-TRUMPS
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.header {
  height: 4rem;
  background-color: #fff;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  z-index: 50;
  @include mq($md) {
    left: 18rem;
    width: calc(100% - 18rem);
    box-shadow: 1px 1px 3px #ddd;
    // justify-content: space-between;
  }

  & > [class^="header__"] {
    height: 100%;
    // display: flex;
    // align-items: center;
  }

  &__left-group {
    margin-right: 1rem;
    @include mq($md) {
      width: 45%;
    }
  }

  &__right-group {
    display: flex;
    
    & > [class^="header__"] {
      margin-right: 1rem;
    }
  }

  &__search {
    height: 100%;
    display: flex;
    align-items: center;
    @include mq($md) {
      flex-wrap: wrap;
    }

    &-icon {
      @include icon(#efcb60, 1.2rem);
      @include mq($md) {
        background-color: #fff;
        cursor: pointer;
        i {
          color: #bcbccb;
        }
      }
    }

    &-input {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      @include mq($md) {
        position: static;
        width: calc(100% - 3rem);
      }

      .icon-left-open {
        color: $b-blue;
        font-size: 2rem;
        @include mq($md) {
          cursor: pointer;
          display: none;
        }
      }

      input[type="text"] {
        border-bottom: 1px solid rgba($b-blue, 0.3);
        height: 2.5rem;
        width: 81%;
        margin-left: 1rem;
        padding-left: 1rem;
        color: $b-blue;
        @include mq($md) {
          margin-left: 0;
          width: 100%;
          border-bottom: 0;
          font-size: 1.2rem;
        }

        &::placeholder {
          color: rgba($b-blue, 0.3);
          opacity: 1;
        }
      }
    }
  }

  &__notify {
    height: 100%;
    display: flex;
    align-items: center;

    &-icon {
      @include icon($b-orange, 1.2rem);
      @include mq($md) {
        background-color: white;
        padding-right: 0.5rem;
        border-right: 1px solid #ebebf2;
        border-radius: 0;
        .icon-notify {
          color: #bcbccb;
          font-size: 1.5rem;
          cursor: pointer;
        }
      }
    }
  }

  &__user {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;

    &-icon {
      @include icon($b-blue, 1.2rem);
      @include mq($lg) {
        cursor: pointer;
      }
      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
    &-name {
      display: none;
      @include mq($md) {
        display: block;
        color: #4d4f5c;
        padding-right: 1rem;
      }
    }
    &-business {
      display: block;
      color: #4d4f5c;
      padding-right: 1rem;
      width: 100px;
      @include mq($sm) {
        width: 200px;
      }
    }
    &-arrow {
      display: none;
      @include mq($md) {
        display: block;
        margin-right: 0.5rem;

        .icon-down-open {
          color: #a4afb7;
          font-size: 1.5rem;
          line-height: 1.5rem;
          cursor: pointer;
        }
      }
    }

    &-logout {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      // opacity: 0;
      // max-height: 0rem;
      // transition: all .3s ease-out;

      ul {
        position: absolute;
        top: 4rem;
        right: 0;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow: hidden;
        li {
          width: 100%;
          text-align: center;
          padding: 1rem 3rem;
          border-bottom: 1px solid rgba($b-blue, 0.15);
          color: rgba(#000, 0.3);
          transition: color 0.3s ease-out;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            color: #000;
            background-color: $b-emph;
          }
        }
      }
    }
  }
}
</style>
